import React from 'react';
import {connect} from "react-redux";
import {startEditWordOfDay} from '../actions/wordOfDay';

export class AdminPage extends React.Component {
    constructor(props) {
        super(props);
        //console.log("AdminPage props = " + JSON.stringify(props, null, 2));
        this.state = {
            ...props
        }
    };

    onWordOfDayChange = (e) => {
        const wordOfDay = e.target.value;
        this.state.wordOfDay = wordOfDay;
        e.preventDefault();
        this.setState(() => ({ error: ''}));
        console.log("onWODChange = " + this.state.wordOfDay);
        this.props.onSubmit({
            wordOfDay: this.state.wordOfDay,
        });
    };

    render() {
        return (
            <div className='content'>
                <p>Welcome, {this.state.name}</p>
                <form onSubmit={this.onSubmit}>
                    <input
                        type='text'
                        placeholder='word of the day'
                        autoFocus
                        className='text-input'
                        value={this.state.wordOfDay}
                        onChange={this.onWordOfDayChange}
                        />
                </form>
            </div>
        )
    }
};

const mapDispatchToProps = (dispatch) => {
    return (
        {
            onSubmit: (wordOfDay) => dispatch(startEditWordOfDay(wordOfDay))
        }
    )
};

const mapStateToProps = (state) => {
    //console.log("AdminPage state = " + JSON.stringify(state, null, 2));
    return (
        {
            name: state.auth.uid.displayName,
            wordOfDay: state.wordOfDay
        }
    )
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminPage);



// WEBPACK FOOTER //
// ./src/components/AdminPage.js